<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VtNNTL/tc-custom/9781504031370.jpg?1734199991964" alt="This image is the cover for the book Death Has a Small Voice, The Mr. and Mrs. North Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death Has a Small Voice, The Mr. and Mrs. North Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Before he dies, a murdered burglar puts Mrs. North in mortal danger</b><br/><br/> The thief struts toward Broadway, confident his luck has finally begun to turn. Just a few hours earlier, he had been as scared as a trapped rat, cowering in a bathroom, hoping the homeowners would go to bed without finding him. He got lucky, and he got away with his mark: a flimsy little piece of plastic that’s worth more money than he’s ever had at one time. But before he reaches his destination, he’ll be left for dead on the sidewalk. As his last act, he drops his loot in the mail.<br/>  <br/> The package is marked for Pamela North, the slightly daffy amateur sleuth who always nabs the killer, even if she never quite gets to the point. One man has already died for this mysterious item, and as soon as it lands in her mailbox, she’ll be in danger of joining him.<br/>  <br/><i>Death Has a Small Voice </i>is the 18th book in the Mr. and Mrs. North Mysteries, but you may enjoy reading the series in any order.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Lockridge, Richard Lockridge
      </h2>
      
      <p class="authorDescription body article">Frances and Richard Lockridge were some of the most popular names in mystery during the forties and fifties. Having written numerous novels and stories, the husband-and-wife team was most famous for their Mr. and Mrs. North Mysteries. What started in 1936 as a series of stories written for the <I>New Yorker</I> turned into twenty-six novels, including adaptions for Broadway, film, television, and radio. The Lockridges continued writing together until Frances&rsquo;s death in 1963, after which Richard discontinued the Mr. and Mrs. North series and wrote other works until his own death in 1982.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f6f839f6